import { useMemo, useState } from 'react';

import { OCCASION } from '@hero/constants';
import { useGetContacts, useGetTagList } from '@hero/services/contact-service/hooks';

function useGetTagBasedAutomationRecipient(automation) {
  const { data: tagContacts } = useGetTagList(
    {
      filters: {
        ids: automation?.contacts?.tags
      },
      options: {
        includeContacts: true
      }
    },
    {
      enabled: !!automation?.contacts?.tags?.length > 0
    }
  );

  const contactIDList = useMemo(() => {
    let list = [];
    if (automation?.contacts?.tags?.length)
      tagContacts?.docs?.map(tag => {
        if (tag.contacts?.length) list.push(...tag.contacts);
      });
    return list;
  }, [tagContacts, automation]);

  const [missingInfoContacts, setMissingInfoContacts] = useState([]);

  const { data: contacts } = useGetContacts(
    {
      filters: {
        ids: contactIDList?.length ? contactIDList : automation?.contacts?.ids
      }
    },
    {
      enabled: automation?.contacts?.ids?.length > 0 || contactIDList?.length > 0,
      onSuccess: data => {
        let missingData = [];
        if (automation?.type === OCCASION.birthday) {
          missingData = data?.docs?.filter(contact => !contact?.birthday?.full);
        }
        if (automation?.type === OCCASION.workAnniversary) {
          missingData = data?.docs?.filter(contact => !contact?.anniversary?.full);
        }
        setMissingInfoContacts(missingData);
      }
    }
  );

  return { contacts, tagContacts, contactIDList, missingInfoContacts };
}

export { useGetTagBasedAutomationRecipient };
